import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";

const AvailableFiltersQuery = graphql(`
  query GetAvailableFilters {
    availableFilters {
      name
      label {
        locale
        value
      }
      parameters {
        name
        operatorGroups {
          operators
          valueType
        }
      }
      category
    }
  }
`);

export function useAvailableFilters() {
  const [result] = useQuery({
    query: AvailableFiltersQuery,
    requestPolicy: "cache-first",
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = isFetching && !data;

  const filters = useMemo(() => data?.availableFilters ?? [], [data]);

  return { filters, isPending, error };
}
